export const SET_PENDING = "state/affiliate-sites/SET_PENDING";
export const SET_TOUCHED = "state/affiliate-sites/SET_TOUCHED";
export const SET_AFFILIATE_SITES = "state/affiliate-sites/SET_AFFILIATE_SITES";
export const FORGET_AFFILIATE_SITES =
  "state/affiliate-sites/FORGET_AFFILIATE_SITES";
